(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["footer"]) return;
  try {
    
GeolizrAPI.addEventListener('geolizr.geoData', function(data) {
  window.currencyCode = data.currencyCode;
  if (window.geoapi) geoapi.switchCurrency(window.currencyCode);
});
  GeolizrAPI.addEventListener('currency.api', function(api) {
   if (window.currencyCode) api.switchCurrency(window.currencyCode);
   window.geoapi = api;
  });
  window.nodeListToArray = function(e, t) {
    for (var n = [], i = 0; i !== e.length; ++i) t && !e[i].matches(t) || n.push(e[i]);
    return n
  };
  window.formatMoney = function(e, t) {
    function n(e, t) {
        return null == e || e !== e ? t : e
    }

    function i(e, t, i, a) {
        if (t = n(t, 2), i = n(i, ","), a = n(a, "."), isNaN(e) || null == e) return 0;
        e = (e / 100).toFixed(t);
        var o = e.split("."),
            s = o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i),
            r = o[1] ? a + o[1] : "";
        return s + r
    }
    "string" == typeof e && (e = e.replace(".", ""));
    var a = /\{\{\s*(\w+)\s*\}\}/,
        o = t || "${{amount}}",
        s = "";
    switch (o.match(a)[1]) {
        case "amount":
            s = i(e, 2);
            break;
        case "amount_no_decimals":
            s = i(e, 0);
            break;
        case "amount_with_space_separator":
            s = i(e, 2, " ", ".");
            break;
        case "amount_no_decimals_with_comma_separator":
            s = i(e, 0, ",", ".");
            break;
        case "amount_no_decimals_with_space_separator":
            s = i(e, 0, " ");
            break;
        case "amount_with_comma_separator":
            s = i(e, 2, ".", ",")
    }
    return o.replace(a, s).replace(".00", "")
  };
  window.convertAll = function(e) {
    var t = this,
        n = {
            USD: {
                money_format: "${{amount}}",
                money_with_currency_format: "${{amount}} USD"
            },
            EUR: {
                money_format: "&euro;{{amount}}",
                money_with_currency_format: "&euro;{{amount}} EUR"
            },
            GBP: {
                money_format: "&pound;{{amount}}",
                money_with_currency_format: "&pound;{{amount}} GBP"
            },
            RUB: {
                money_format: "&#8381; {{amount_no_decimals_with_comma_separator }}",
                money_with_currency_format: "&#8381; {{amount_no_decimals_with_comma_separator }} RUB"
            }
        },
        a = window.theme.shopCurrency,
        o = window.currencyCode;
    nodeListToArray(document.querySelectorAll("[data-money-convertible]")).forEach(function(e) {
        if (e.hasAttribute("data-currency-" + a) || e.setAttribute("data-currency-" + a, e.innerHTML), e.getAttribute("data-currency") !== o) {
            var i = e.getAttribute("data-currency-" + a);
            if (e.hasAttribute("data-currency-" + o)) e.innerHTML = e.getAttribute("data-currency-" + o);
            else {
                var new_price = parseInt(i.replace(/[^0-9]/g, ""), 10);
                if (o == "USD") {
                    new_price = new_price * 1.13260
                }
                if (o == "GBP") {
                    new_price = new_price * 0.857237
                } else {
                    new_price = new_price
                }
                var s = parseInt(i.replace(/[^0-9]/g, ""), 10);
                var r = n[a][window.theme.currencyConversionMoneyFormat] || "{{amount}}";
                var l = n[o][window.theme.currencyConversionMoneyFormat] || "{{amount}}"; - 1 === i.indexOf(".") && -1 === r.indexOf("amount_no_decimals") && (s *= 100), s = r.indexOf("amount_no_decimals") !== -1 ? window.Currency.convert(100 * s, a, o) : "JOD" === a || "KWD" === a || "BHD" === a ? window.Currency.convert(s / 10, a, o) : window.Currency.convert(s, a, o), window.theme.currencyConversionRoundAmounts && (s = 100 * Math.round(s / 100));
                (new_price = 100 * Math.round(new_price / 100));
                var c = t.formatMoney(s, l);
                e.innerHTML = c, e.setAttribute("data-currency-" + o, c)
            }
            e.setAttribute("data-currency", o)
        }
    }), localStorage.setItem("currency", o)
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["list-collection-products-3"]) return;
  try {
    
function scrollOnLoad() {
 $("div.ProductList--carousel").scrollLeft(70);
  $(document).on('click', '.toggle-open', function(event){
    if(event.handled === false) return
    event.stopPropagation();
    event.handled = true;
    $(this).next().show();
    $(this).hide();
    $(this).parents('div.CollectionMain').find('.ProductList--carousel').css('white-space','normal');
  });
  $(document).on('click', '.toggle-close', function(event){
    if(event.handled === false) return
    event.stopPropagation();
    event.handled = true;
    $(this).prev().show();
    $(this).hide();
    $(this).parents('div.CollectionMain').find('.ProductList--carousel').css('white-space','nowrap');
  });
}
if (window.addEventListener)
{
  window.addEventListener("load", scrollOnLoad, false);
}
else if (window.attachEvent)
{
  window.attachEvent("onload", scrollOnLoad);
}
else
{
  window.onload = scrollOnLoad;
}

  } catch(e) { console.error(e); }
})();

})();
